
let template = require('./speaker_nominate_status_legend.twig');

export class SpeakerNominateStatusLegend {
    constructor() {
        this.dom = $(twig({ data: template }).render({statusLegends: app.appData.speakerNominateStatus}));
        this.modal = new bootstrap.Modal(this.dom, {backdrop: 'static', keyboard: false, show: false});
    }
}
